<script lang="ts" setup>
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useModalsStore} from "@/stores/modals";
import {togglePassword} from "@/helpers/togglePassword";

const modalStore = useModalsStore()

const toggleMenu = (): void => {
  modalStore.isLoginModalShown = !modalStore.isLoginModalShown
}

const formWrapper = ref<null | HTMLDialogElement>(null)

const keydownHandler = (e: KeyboardEvent): void => {
  if (e.code && e.code.toLowerCase() !== 'escape') {
    return
  }

  modalStore.isLoginModalShown = false
}

const clickHandler = (e: MouseEvent): void => {
  if ((e.target as HTMLElement).closest('.modal-wrapper')) {
    return
  }

  toggleMenu()
}

watch(() => modalStore.isLoginModalShown, (): void => {
  setTimeout(() => {
    if (modalStore.isLoginModalShown) {
      window.addEventListener('keydown', keydownHandler)
      window.addEventListener('click', clickHandler)

      return
    }

    window.removeEventListener('keydown', keydownHandler)
    window.removeEventListener('click', clickHandler)
  }, 0)
})

onMounted(() => {
  init()
})

onBeforeUnmount(() => {
  const form = formWrapper.value?.querySelector('form')

  if (!form) {
    return
  }

  form.removeEventListener('onAfterFormieSubmit', submitHandler);
})

const submitHandler = () => {
  setTimeout(() => {
    window.location.replace(window.location.href)
  }, 0)
}

const init = () => {
  const form = formWrapper.value?.querySelector('form')

  if (!form) {
    return
  }
  
  // @ts-ignore
  window.Formie.initForm(form)

  form.addEventListener('onAfterFormieSubmit', submitHandler);

  togglePassword()
}
</script>

<template>
  <div class="flex w-full modal-wrapper">
    <div class="flex w-full cursor-pointer login-modal__handler" @click.prevent.capture="toggleMenu">
      <slot></slot>
    </div>

    <div v-show="modalStore.getLoginModalStatus" class="absolute top-full right-0 bg-white w-[542px] px-5 border">
      <div class=""><h4 class="font-myriadPro pt-[1.875rem] leading-[2.25rem]">Авторизация</h4>
        <div ref="formWrapper" class="grid grid-cols-1 py-[1.875rem]">
          <slot name="form"/>
        </div>
      </div>
    </div>
  </div>
</template>
